// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"1f29d371","787":"c524065b"}[chunkId] + ".chunk.js";
};